interface NationalFlagProps {
  /** Flag image URL. */
  src: string | null;
}

export default function NationalFlag({ src }: NationalFlagProps) {
  return (
    <>
      {src ? (
        <img src={src} alt="National flag" className="size-[40px] object-cover rounded-[12px]" />
      ) : (
        <div className="size-[40px]" />
      )}
    </>
  );
}
